/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */
import React from "react";
import divorcePlannerModalStyle from "./divorcePlannerModalStyle";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { Link } from "react-router";
import { getCaseLink } from "../../../services/productService";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import { Box } from "@mui/material";
import { PARTNER_IRIS } from "../../../constants/partnerIris";

type DivorcePlannerModalProps = {
  divorce: AbstractCase;
  open: boolean;
  onClose: () => void;
};
const DivorcePlannerModal = ({ divorce, open, onClose }: DivorcePlannerModalProps) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Jetzt Scheidungsplaner freischalten!</DialogTitle>
      <DialogContent>
        <p>
          Nur bei Legalbird erhalten Sie einen interaktiven Scheidungsplaner mit allen Details zum Ablauf, Tipps und Checklisten - genau auf Ihre persönliche
          Situation ausgerichtet!
        </p>
        <p>Der Scheidungsplaner richtet sich an Sie persönlich und basiert daher auf den Angaben zu Ihrer Scheidung.</p>
        <p>
          <strong>
            Sobald Sie alle Angaben eingetragen {divorce.acquisitionPartner !== PARTNER_IRIS.ADVOCARD && "und die Vollmacht erteilt"} haben, erhalten Sie kostenlos
            Zugriff!
          </strong>
        </p>
      </DialogContent>
      <DialogActions>
        <Box sx={divorcePlannerModalStyle.buttonContainer}>
          <Button component={Link} to={getCaseLink(divorce) + "/antrag"} fullWidth color={"primary"} variant={"contained"}>
            Angaben vervollständigen
          </Button>
          <Button component={Link} to={getCaseLink(divorce)} fullWidth color={"primary"} variant={"text"} sx={divorcePlannerModalStyle.backButton}>
            Zurück zum Fall
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default DivorcePlannerModal;
